import { render } from "./QuestionTwoScreen.vue?vue&type=template&id=a1161404&scoped=true&lang=html"
import script from "./QuestionTwoScreen.vue?vue&type=script&lang=js"
export * from "./QuestionTwoScreen.vue?vue&type=script&lang=js"

import "./QuestionTwoScreen.vue?vue&type=style&index=0&id=a1161404&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1161404"]])

export default __exports__